import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { SUMMARY_LABEL_SX, SummaryField } from './SummaryPaneComponents';
import { useAnalysisSelectors } from '../hooks';
import ZuulQueryBuilder from '../../QueryBuilder/ZuulQueryBuilder';
import { useDomains } from '../../../views/OfferBlocks/queries';
import { Entity } from '../../../views/CustomProperties/EntityGroups/details/types';
import { useSites } from '../../../views/Sites/queries';
import { useAffiliates } from '../../../views/Affiliates/queries';
import ZuulLoader from '../../ZuulLoader/ZuulLoader';
import { randomFailureFields } from '../../../utils/queryBuilderFields';
import { useLandingPagesDtos } from '../../../views/LandingPages/queries';
import { useLandingPageGroupsDtos } from '../../../views/LandingPageGroups/queries';

const AnalysisSummary = () => {
  const analysisSelectors= useAnalysisSelectors();
  const {data: domains = [], isLoading: loadingDomains} = useDomains(true, (data: { id: any; name: any; }[]): Entity[] =>
    data.map((domain: { id: any; name: any; }) => ({
      id: domain.id,
      name: domain.name
    }))
  );

  const {data: sites = [], isLoading: loadingSites} = useSites((data): Entity[] =>
    data.map((site: { id: any; domain: any; }) => ({
      id: site.id,
      name: site.domain
    }))
  );

  const {data: affiliates = [], isLoading: loadingAffiliates} = useAffiliates(true, (data): Entity[] =>
    data.map((affiliate: { id: any; name: any; }) => ({
      id: affiliate.id,
      name: affiliate.name
    }))
  );

  const {data: landingPages = [], isLoading: loadingLandingPages} = useLandingPagesDtos((data): Entity[] =>
    data.map((landingPage: any) => ({
      id: landingPage.id,
      name: landingPage.offer.name
    }))
  );

  const {data: landingPageGroups = [], isLoading: loadingLandingPageGroups} = useLandingPageGroupsDtos((data): Entity[] =>
    data.map((landingPageGroup: { id: any; name: any; }) => ({
      id: landingPageGroup.id,
      name: landingPageGroup.name
    }))
  );

  if (loadingDomains || loadingSites || loadingAffiliates || loadingLandingPages || loadingLandingPageGroups) {
    return <ZuulLoader text={"Loading Query Builder Fields..."} />;
  }

  if (!analysisSelectors.isAnySelectorNotNullOrEmpty) {
    return <></>;
  }



  return (
    <>
      <Typography variant='h4'>Analysis Summary</Typography>
      <hr />
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <Grid size='grow'>
          {analysisSelectors.randomFailureProbabilities.map((probability: any, index: number) => (
            <div key={index}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                      <Grid size={3}>
                        <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Failure Probability</FormLabel>
                        <SummaryField value={`${probability.probability * 100}%`} />
                      </Grid>
                      {probability.condition && probability.condition !== 'false' && (
                        <Grid size='grow'>
                          <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Condition</FormLabel>
                          <ZuulQueryBuilder query={probability.condition} setQuery={()=>{}} fields={randomFailureFields(domains, affiliates, sites, landingPages, landingPageGroups)} isSummary/>
                        </Grid>
                      )}
                    </Grid>
                  </CardContent>
                </Card>
            </div>
          ))}
        </Grid>
      </Grid>
    </>
  );
};

export default AnalysisSummary;
